import React from 'react';
import { observer, inject } from 'mobx-react';
import { Row, Pagination } from 'antd';
import styles from './AppStrategy.less';
import AppStrategyItem from '../../components/AppStrategy/AppStrategyItem';
import AddStrategy from '../../components/AppStrategy/AddStrategy';
import SyncModal from '../../components/AppStrategy/SyncModal';
import AppProgressModal from '../../components/AppStrategy/AppProgressModal';
import AcrossVersionsModal from '../../components/AppStrategy/AcrossVersionsModal';
import SyncAccrossVersionsModal from '../../components/AppStrategy/SyncAcrossVersionsModal';
import Title from '@/components/Title';
import Loading from '../../components/Loading';

@inject('appStrategyStore', 'appFileStore')
@observer
class AppStrategy extends React.Component {
  componentDidMount() {
    this.props.appFileStore.loadAppList();
    this.props.appStrategyStore.loadAppStrategyList(
      this.props.appStrategyStore.currentPage,
      this.props.form
    );
  }
  componentWillUnmount() {
    this.props.appStrategyStore.resetObservable();
  }
  render() {
    const {
      strategyList,
      listPageTotal,
      showAddStrategyModal,
      SyncModalStatus,
      hideSyncModal,
      currentPage,
      changePage
    } = this.props.appStrategyStore;
    const { appListArr } = this.props.appFileStore;
    return (
      <div className={styles.appStrategyContainer}>
        <Row className={styles.titleContainer}>
          <Title
            titleText={'策略列表'}
            btn={{
              text: '新建策略',
              func: showAddStrategyModal,
              state: true
            }}
          />
        </Row>
        {[...strategyList].map((item, a) => (
          <AppStrategyItem key={a} data={item} appListArr={appListArr} />
        ))}
        <div className={styles.paginContaoner}>
          <Pagination
            onChange={changePage}
            current={currentPage}
            total={listPageTotal}
            defaultPageSize={10}
            hideOnSinglePage={true}
          />
        </div>
        <AddStrategy appListArr={appListArr} />
        <SyncModal status={SyncModalStatus} hideFunc={hideSyncModal} />
        <AppProgressModal />
        <AcrossVersionsModal />
        <Loading />
        <SyncAccrossVersionsModal />
      </div>
    );
  }
}
export default AppStrategy;



// WEBPACK FOOTER //
// ./src/pages/AppStrategy/AppStrategy.js